import { useEffect } from "react";

const FoodBeverages = () => {
  useEffect(() => {
    document.title = "Food Beverages - Deww Botanicals";
  }, []);

  return (
    <>
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/foodbanner.jpg)` }}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">
            Food & Beverages
          </h1>
        </div>
      </div>

      <div className="container-xxl py-3 container-fluid p-0 mb-5 blog-wrapper">
        <div className="container">
          <div className="row my-3">
            <div className="col-12 col-md-9 m-auto">
              {/* <h2>Food &amp; Beverages</h2> */}
              <h3>Pure Ingredients, Flavorful Impact</h3>
              <p>
                <strong>
                  The Role of Natural Oils, Extracts, and Butters in the Food
                  and Beverage Industry
                </strong>
              </p>

              <p>
                At Deww Botanicals, we believe that food should not only nourish
                but also heal, energize, and delight. Our range of natural
                essential oils, carrier oils, liquid extracts, oleoresins, and
                plant butters provides exceptional value to the food and
                beverage industry, combining flavor, function, and nutrition in
                every drop.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Natural+Ingredients+in+Food+%26+Beverages" alt="Natural Ingredients in Food & Beverages" /> */}

              <h4>Ingredient Functions in Food and Beverages</h4>

              <h5>Carrier Oils: Nutritional Base and Functional Fats</h5>
              <p>
                Cold-pressed carrier oils such as coconut, sesame, flaxseed, and
                black seed (kalonji) are widely used for:
              </p>
              <ul>
                <li>Cooking, dressings, and nutritional supplements</li>
                <li>
                  Providing essential fatty acids (omega-3 and omega-6) and
                  fat-soluble vitamins
                </li>
                <li>Supporting heart health, digestion, and immunity</li>
                <li>
                  Acting as solvents or carriers for fat-soluble nutraceutical
                  ingredients
                </li>
              </ul>
              <p>
                These oils serve both culinary and health functions in modern
                formulations.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Cold-Pressed+Carrier+Oils" alt="Carrier Oils" /> */}

              <h5>
                Essential Oils: Flavoring Agents and Natural Preservatives
              </h5>
              <p>
                Food-grade essential oils, including lemon, orange, peppermint,
                ginger, and basil, offer:
              </p>
              <ul>
                <li>
                  Intense natural flavor and aroma for beverages, candies, teas,
                  and baked goods
                </li>
                <li>
                  Antimicrobial and antioxidant properties that extend shelf
                  life
                </li>
                <li>
                  Functional applications in digestive aids, detox blends, and
                  flavored waters
                </li>
              </ul>
              <p>
                Used in micro-quantities, essential oils add a high-impact
                sensory value while being 100% natural.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Food-Grade+Essential+Oils" alt="Essential Oils" /> */}

              <h5>
                Liquid Herbal Extracts: Functional and Nutraceutical Additions
              </h5>
              <p>
                Water- or alcohol-based herbal extracts such as tulsi, amla,
                ashwagandha, moringa, and turmeric are:
              </p>
              <ul>
                <li>
                  Utilized in immunity shots, herbal teas, wellness drinks, and
                  energy tonics
                </li>
                <li>
                  Ideal for functional beverages, health syrups, and detox
                  elixirs
                </li>
                <li>
                  Delivering bioavailable, plant-based nutrients without heavily
                  altering the flavor
                </li>
              </ul>
              <p>
                These extracts bring the Ayurvedic heritage of healing herbs
                into modern health beverages.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Liquid+Herbal+Extracts" alt="Liquid Herbal Extracts" /> */}

              <h5>Oleoresins: Concentrated Spice and Phytochemical Extracts</h5>
              <p>
                Oleoresins are highly concentrated, oil-soluble extracts from
                spices like chili, turmeric, black pepper, cumin, clove, and
                cardamom. They are used for:
              </p>
              <ul>
                <li>Flavoring sauces, snacks, seasonings, and beverages</li>
                <li>
                  Coloring agents (e.g., turmeric oleoresin for golden hues)
                </li>
                <li>
                  Delivering uniform, controlled spice flavor with high
                  stability in formulations
                </li>
              </ul>
              <p>
                Oleoresins are preferred over raw spices for their standardized
                potency and longer shelf life.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Oleoresins+for+Flavor+%26+Color" alt="Oleoresins" /> */}

              <h5>Plant Butters: Clean-Label Fats and Texture Enhancers</h5>
              <p>
                Natural butters, such as cocoa butter and shea butter, are used
                in:
              </p>
              <ul>
                <li>Confectionery (chocolates, truffles, frostings)</li>
                <li>Baking for rich texture and creaminess</li>
                <li>Nutritional bars and spreads as sources of healthy fats</li>
              </ul>
              <p>
                These butters contribute to mouthfeel, richness, and stability,
                making them favored ingredients in gourmet and health-conscious
                foods.
              </p>

              {/* <img src="https://via.placeholder.com/800x400?text=Natural+Plant+Butters+in+Food" alt="Plant Butters" /> */}

              <h4>Why Food and Beverage Brands Trust Deww Botanicals:</h4>
              <ul>
                <li>Food-grade, cold-pressed, and solvent-free ingredients</li>
                <li>Non-GMO, preservative-free, and clean-label</li>
                <li>Tested for purity, consistency, and compliance</li>
                <li>Ayurveda-inspired and globally relevant</li>
              </ul>

              <h4>From Tradition to Innovation</h4>
              <p>
                Whether you are formulating a functional drink, a nutritious
                snack, or a plant-based culinary experience, Deww Botanicals
                provides the natural oils, extracts, oleoresins, and butters
                that add depth, performance, and purity to your products.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FoodBeverages;
